'use client';

import React, { useEffect, useState } from 'react';
import { Monitor, Terminal, Zap } from 'lucide-react';

type Theme = 'default' | 'matrix' | 'retro' | 'win98';

export default function ThemeSelector() {
  const [theme, setTheme] = useState<Theme>('default');

  useEffect(() => {
    // Apply theme to body
    document.body.className = ''; // Reset
    document.body.classList.add(`theme-${theme}`);
    
    // Save to local storage for persistence
    localStorage.setItem('lan-theme', theme);
  }, [theme]);

  useEffect(() => {
    const saved = localStorage.getItem('lan-theme') as Theme;
    if (saved) setTheme(saved);
  }, []);

  return (
    <div className="flex bg-slate-900 border border-slate-800 rounded-lg p-1 gap-1">
      <button 
        onClick={() => setTheme('default')}
        className={`p-2 rounded transition-all ${theme === 'default' ? 'bg-blue-600 text-white shadow' : 'text-slate-500 hover:text-white'}`}
        title="Modern (Default)"
      >
        <Monitor size={16} />
      </button>
      <button 
        onClick={() => setTheme('matrix')}
        className={`p-2 rounded transition-all ${theme === 'matrix' ? 'bg-green-600 text-white shadow' : 'text-slate-500 hover:text-green-400'}`}
        title="Matrix Hackerman"
      >
        <Terminal size={16} />
      </button>
      <button 
        onClick={() => setTheme('retro')}
        className={`p-2 rounded transition-all ${theme === 'retro' ? 'bg-amber-600 text-white shadow' : 'text-slate-500 hover:text-amber-400'}`}
        title="Retro / Fallout"
      >
        <Zap size={16} />
      </button>
      <button 
        onClick={() => setTheme('win98')}
        className={`p-2 rounded transition-all ${theme === 'win98' ? 'bg-slate-400 text-black shadow border border-white' : 'text-slate-500 hover:text-slate-200'}`}
        title="Windows 98"
      >
        <div className="w-4 h-4 border-t-2 border-l-2 border-white bg-slate-300 relative">
          <div className="absolute inset-0 border-r border-b border-slate-600"></div>
        </div>
      </button>
    </div>
  );
}
